import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-wrap py-2 pl-2 pr-2 justify-content-between flex-row surface-border border-bottom-2" }
const _hoisted_2 = { class: "flex flex-wrap flex-row align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "flex align-items-center md:mb-0 text-gray-900 no-underline",
  style: {"width":"230px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/pifema-logo-dark.svg",
    width: "130"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-2xl ml-2",
    style: {"padding-top":"0.2rem"}
  }, "SPOT")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "cursor-pointer block lg:hidden text-700 mr-3 mt-1 p-ripple"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars text-4xl" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex flex-row justify-content-between align-items-center relative lg:static" }
const _hoisted_8 = { class: "cursor-pointer block lg:hidden text-700 p-ripple" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-v text-2xl" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "min-w-max headermenu list-none p-0 m-0 hidden lg:flex lg:align-items-center select-none lg:flex-row surface-section border-1 lg:border-none surface-border right-0 top-100 z-2 shadow-2 lg:shadow-none absolute lg:static" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-book text-base mr-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Objednávky", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-warehouse text-base mr-2" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Sklad", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users text-base mr-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Užívatelia", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-power-off text-base mr-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Odhlásiť sa", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-base mr-2" }, null, -1)
const _hoisted_24 = { class: "font-medium" }
const _hoisted_25 = { class: "flex relative lg:static surface-ground" }
const _hoisted_26 = { class: "flex-column flex" }
const _hoisted_27 = { class: "overflow-y-auto" }
const _hoisted_28 = { class: "flex flex-column relative flex-auto surface-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ManageOrders = _resolveComponent("ManageOrders")!
  const _component_ManageStock = _resolveComponent("ManageStock")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_styleclass = _resolveDirective("styleclass")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        ($data.store.selectModul != '')
          ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, _hoisted_6)), [
              [_directive_ripple],
              [_directive_styleclass, { selector: '#sidebar-1', enterClass: 'hidden', enterActiveClass: 'fadeinleft',
                      leaveToClass:'hidden', leaveActiveClass:'fadeoutleft', hideOnOutsideClick:true}]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, _hoisted_10)), [
          [_directive_ripple],
          [_directive_styleclass, { selector:'.headermenu', enterClass:'hidden', enterActiveClass:'fadein', leaveToClass:'hidden', leaveActiveClass:'fadeout', hideOnOutsideClick:true}]
        ]),
        _createElementVNode("ul", _hoisted_11, [
          _createElementVNode("li", null, [
            ($data.store.token != '' )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:void(0);",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.setRoute('mod-orders/orders'))),
                  class: "hidden lg:block mr-2"
                }, [
                  _createVNode(_component_PrimevueButton, {
                    label: "Objednávky",
                    severity: "primary",
                    text: "",
                    raised: ""
                  })
                ]))
              : _createCommentVNode("", true),
            ($data.store.token != '' )
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "javascript:void(0);",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.setRoute('mod-orders/orders'))),
                  class: "block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors p-ripple"
                }, _hoisted_14)), [
                  [_directive_ripple]
                ])
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", null, [
            ($data.store.token != '' && ($data.store.user.admin === true || $data.store.user.department.id == 3 || $data.store.user.department.id == 1))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:void(0);",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.setRoute('mod-stock'))),
                  class: "hidden lg:block mr-2"
                }, [
                  _createVNode(_component_PrimevueButton, {
                    label: "Sklad",
                    severity: "primary",
                    text: "",
                    raised: ""
                  })
                ]))
              : _createCommentVNode("", true),
            ($data.store.token != '' && ($data.store.user.admin === true || $data.store.user.department.id == 3 || $data.store.user.department.id == 1))
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "javascript:void(0);",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.setRoute('mod-stock'))),
                  class: "block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors p-ripple"
                }, _hoisted_17)), [
                  [_directive_ripple]
                ])
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", null, [
            ($data.store.token != '' && $data.store.user.admin === true)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/admin/users",
                  class: "hidden lg:block mr-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PrimevueButton, {
                      label: "Užívatelia",
                      severity: "info",
                      text: "",
                      raised: ""
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($data.store.token != '' && $data.store.user.admin === true)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/admin/users",
                  class: "block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors p-ripple"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _hoisted_19
                  ]),
                  _: 1
                })), [
                  [_directive_ripple]
                ])
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.logout())),
              class: "hidden lg:block mr-2"
            }, [
              _createVNode(_component_PrimevueButton, {
                label: "Odhlásiť sa",
                plain: "",
                text: "",
                raised: ""
              })
            ]),
            _withDirectives((_openBlock(), _createElementBlock("a", {
              href: "javascript:void(0);",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.logout())),
              class: "block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors p-ripple"
            }, _hoisted_22)), [
              [_directive_ripple]
            ])
          ]),
          _createElementVNode("li", null, [
            ($data.store.token != '')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: `/admin/users/${this.store.user.id}`,
                  class: "hidden lg:block mr-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PrimevueButton, {
                      label: this.store.user.firstName ?? '',
                      severity: "info",
                      text: "",
                      raised: "",
                      class: "font-medium text-base text-800"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            ($data.store.token != '')
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: `/admin/users/${this.store.user.id}`,
                  class: "block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors p-ripple"
                }, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _createElementVNode("span", _hoisted_24, _toDisplayString(this.store.user.firstName) + " " + _toDisplayString(this.store.user.lastName), 1)
                  ]),
                  _: 1
                }, 8, ["to"])), [
                  [_directive_ripple]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      ($data.store.selectModul != '')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "sidebar-1",
            class: "surface-section hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-5 border-right-1 surface-border select-none",
            style: _normalizeStyle([{"width":"230px"}, { height: `${$data.vh - 165}px` }])
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                ($data.store.selectModul == 'mod-orders')
                  ? (_openBlock(), _createBlock(_component_ManageOrders, { key: 0 }))
                  : _createCommentVNode("", true),
                ($data.store.selectModul == 'mod-stock')
                  ? (_openBlock(), _createBlock(_component_ManageStock, { key: 1 }))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 64))
}